export const config = {
    authApiUrl: process.env.REACT_APP_AUTH_API_URL || 'http://localhost:4000',
    authAzureApiUrl: process.env.REACT_APP_AUTH_AZURE_API_URL || 'http://localhost:4000',
    graphqlApiUrl: process.env.REACT_APP_GRAPHGQL_API_URL || 'http://localhost:8080/query',
    graphqlJobApiUrl: process.env.REACT_APP_GRAPHGQL_JOB_API_URL || 'http://localhost:8080/query',
    queryStoreApiUrl: process.env.REACT_APP_GRAPHGQL_QUERY_STORE_API_URL || 'http://localhost:8080',
    symphonyApiUrl: process.env.REACT_APP_SYMPHONY_API_URL || 'http://localhost:8080',
    directoryTilesUrl: process.env.REACT_APP_DIRECTORY_TILES_URL || 'https://directory-tiles-staging.liveapp.com',
    directoryMapFeedUrl: process.env.REACT_APP_DIRECTORY_MAP_FEED_URL || 'https://directory-map-feed-staging.liveapp.com',
    mapsManagerApiUrl: process.env.REACT_APP_MAPS_MANAGER_API_URL || 'https://maps-manager-api-staging.liveapp.com',
};
